<template>
    <div class="p-5">
        <div class="col-md-8 mx-auto py-0 my-0" v-if="fields.length > 0" v-for="item in properties"
             :key="item.label" :data-name="item.label">
            <component
                    :key="item.name"
                    :is="item.name === 'transformable_price' ? 'forRent' :item.component "
                    item-value="key"
                    item-text="lable"
                    :items="item.items"
                    v-model="param[item.name]"
                    :hint="item.hint"
                    :max="item.counter"
                    :maxLength="item.max"
                    rows="13"
                    :min="item.min"
                    :label="item.label"
                    oninput="if(Number(this.value) > Number(this.max) && this.type === 'number') this.value = this.max"
                    outlined
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    small-chips
                    :required="item.required"
                    :rules="item.rules"
                    :type="item.type"
                    :error-messages="item.errorMessage"
                    :name="item.name"
                    :placeholder="item.placeholder"
                    :multiple="item.name === 'colored_parts' "
                    dense>
            </component>
        </div>
    </div>
</template>

<script>
import {VAutocomplete, VSelect, VSwitch, VTextarea, VTextField} from "vuetify/lib/components";

export default {
    name: "edit_other_attrs",
    props: {
        param: {
            type: Object,
            require: true
        },
        fields: {
            required: true
        },
    },
    data() {
        return {
            extra: [],
            inputs: {
                "radio": VSelect,
                "string": VTextField,
                "TextFieldWidget": VTextField,
                "number": VTextField,
                "hierarchy_widget": VSelect,
                "SingleSelectHierarchyWidget": VSelect,
                "select": VAutocomplete,
                "textarea": VTextarea,
                "boolean": VSwitch,
                "array": VAutocomplete,
                "object": VAutocomplete,
                "checkboxes": VAutocomplete
            },
        };
    },
    methods: {
        getProperty(key) {
            const name = key.name;
            const min = key.min
            const max = key.max;
            const help = key.placeholder;
            const requireField = key.required;
            const placeholder = key.placeholder;
            const autoReload = key.auto_refresh;
            const has_field = key.fields
            let items = [];
            let type = key.field_type !== null ? key.field_type : (key.type !== 'integer' ? key.type : "number");
            let title = key.title;
            let itemValue = key.enum ?? [];
            let itemText = key.enumNames ?? itemValue;

            itemValue.forEach((item, index) => {
                items.push({
                    key: item,
                    lable: itemText[index]
                })
            })

            return {
                component: this.inputs[type],
                label: title,
                counter: max ? max : null,
                hint: help ? help : null,
                items: items,
                name: name,
                min: min,
                value: this.param[name] || "",
                required: requireField,
                placeholder: placeholder,
                has_fields: has_field,
                errorMessage: "",
                autoReload: autoReload,
                rules: [
                    (v) => {
                        if ((name === "title" || name === "description"))
                            return (this.required === true ? v < max : v.length <= max) || 'مقدار وارد شده بیش از حد مجاز است.حداکثر مقدار موردنیاز ' + max + ' است.';
                        else if (["boolean", "select", "string", "object", "number", "array", "hidden", "radio", "SingleSelectHierarchyWidget", "checkboxes", "hierarchy_widget"].indexOf(type) > -1)
                            return true;
                    },
                    (v) => {
                        if ((name === "title" || name === "description"))
                            return (this.required === true ? v > min : v.length >= min) || 'مقدار وارد شده کمتر از حد مجاز است.حداقل مقدار موردنیاز  ' + min + ' است.';
                        else if (["boolean", "select", "object", "string", "number", "array", "hidden", "number", "radio", "checkboxes", "hierarchy_widget"].indexOf(type) > -1)
                            return true;

                    },
                ],
                type: type,
            };
        },
    },
    computed: {
        properties() {
            let properties = [];

            this.fields.filter(item => {
                return item.field_type || item.name === "rebuilt"
            }).forEach((item) => {
                properties.push(this.getProperty(item));
            });

            return properties;
        },
    }
}
</script>

<style scoped>

</style>